module.exports = __webpack_public_path__ + "img/ga.4944db21.svg";